import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import MUITypography from "../../Components/MUITypography";
import { align_row, VM_Colors } from "../../Styles/VMStyles";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTE_ROOMS_REGISTRATION } from "../../Util/VMConstants";
import { toTitleCase } from "../../Util/UtilHelper";

function VMRegistrationSuccess() {
  const user_id = useLocation().state?.user_id || null;  
    
    
  const navigate = useNavigate();

useEffect(() => {
  // 1️⃣ Replace current history entry (clears previous route)
  window.history.replaceState(null, "", window.location.href);

  // 2️⃣ Handle browser back button
  const handleBack = () => {
    navigate("/login", { replace: true });
  };

  // 3️⃣ Push dummy state to trap back navigation
  window.history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", handleBack);

  return () => {
    window.removeEventListener("popstate", handleBack);
  };
}, [navigate]);


  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #5E4B8B 0%, #6B5CA5 100%)",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 500,
          px: 3,
        }}
      >
        {/* Success Icon */}
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 140,
            height: 140,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            mb: 3,
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: 90,
              color: "#0A8A42", // green tick
            }}
          />
        </Box>

        {/* Title */}
        <MUITypography
          variant="h3"
          sx={{
            fontWeight: 700,
            color: "#ffffff",
            mb: 1,
          }}
        >
          Registration Successful
        </MUITypography>

        {/* Subtitle */}
        <MUITypography
          variant="body1"
          sx={{
            color: "#E6E1F2",
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          {toTitleCase('Your account and venue setup have been completed successfully.  You can now start managing your venue.')}
        </MUITypography>

        <Box sx={{mt:10 ,...align_row, justifyContent: 'center' }}>
           <Button
          variant="contained"
          size="large"
          sx={{
            bgcolor: "#ffffff",
            color: VM_Colors.primary,
            px: 5,
            py: 1.5,
            fontWeight: 600,
            fontSize: "16px",
            minWidth:250,
            borderRadius: 2,
            textTransform: "none",
            "&:hover": {
              bgcolor: "#f2f2f2",
            },
          }}
          onClick={() => navigate("/login")}
        >
          Click Here To Login
        </Button>
          <Button
          variant="contained"
          size="large"
          sx={{
            bgcolor: "#ffffff",
            color: VM_Colors.primary,
            px: 5,
            py: 1.5,
            minWidth:250,
            ml:5,
            fontWeight: 600,
            borderRadius: 2,
            textTransform: "none",
            "&:hover": {
              bgcolor: "#f2f2f2",
            },
          }}
          onClick={() =>
            navigate(`/${ROUTE_ROOMS_REGISTRATION}`, {
              state: { user_id },
              replace: true,
            })
          }
          
        >
          Click Here For Room Registration
        </Button>
        </Box>  

      </Box>
    </Box>
  );
}

export default VMRegistrationSuccess;
